"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    InfoLabel: function() {
        return _index.InfoLabel;
    },
    infoLabelClassNames: function() {
        return _index.infoLabelClassNames;
    },
    renderInfoLabel_unstable: function() {
        return _index.renderInfoLabel_unstable;
    },
    useInfoLabelStyles_unstable: function() {
        return _index.useInfoLabelStyles_unstable;
    },
    useInfoLabel_unstable: function() {
        return _index.useInfoLabel_unstable;
    }
});
const _index = require("./components/InfoLabel/index");
